export default __webpack_public_path__ + "static/media/2087-00.a707e655.jpg";